<template>
  <div style="display: inline;">
    <yi_curd_table v-bind="$attrs" :name="$options.name" getUrl="/web/mixture/order/page" ref="yt" getKey="rows" :columns="columns">
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('hunliaogongdanhao')">
            <el-input v-model="yt.conditions.no" size="mini" clearable></el-input>
          </el-form-item>

          <el-form-item :label="$t('shengchangongdanhao')">
            <el-input v-model="yt.conditions.woNo" size="mini" clearable></el-input>
          </el-form-item>

          <el-form-item :label="$t('chuangjianshijian')">
            <yi_time_input type="datetimerange" :start.sync="yt.conditions.createBeginTime" :end.sync="yt.conditions.createEndTime"></yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('wanchengshijian')">
            <yi_time_input type="datetimerange" :start.sync="yt.conditions.finishBeginTime" :end.sync="yt.conditions.finishEndTime"></yi_time_input>
          </el-form-item>

          <el-form-item :label="$t('gongdanzhuangtai')">
            <yi_dictionary_select :max="8" :type="'MIXTURE_ORDER_STATUS'" :ids.sync="yt.conditions.status"></yi_dictionary_select>
          </el-form-item>

          <el-form-item :label="$t('hunqianbaohanliaohao')">
            <yi_data_select :multiple="false" :type="'material2'" :ids.sync="yt.conditions.materialId"></yi_data_select>
          </el-form-item>

          <el-form-item :label="$t('hunhoushengchengliaohao')">
            <el-input v-model="yt.conditions.mixtureNo" size="mini" clearable></el-input>
          </el-form-item>

          <el-form-item :label="$t('hunliaoshijian')">
            <yi_time_input type="datetimerange" :start.sync="yt.conditions.feedingTimeBegin" :end.sync="yt.conditions.feedingTimeEnd"></yi_time_input>
          </el-form-item>

          <el-form-item :label="$t('zhixingren')">
            <el-input v-model="yt.conditions.pic" size="mini" clearable></el-input>
          </el-form-item>

          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear({ feedingTimeBegin: begin(),feedingTimeEnd: end() })">{{ $t('chongzhi') }}</el-button>
            <yi_curd_expand_button :isAutoExpand="true"></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>

      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button size="mini" type="primary" @click="yt.showEditDialog('xinzeng', '', '1480px')">
          {{ $t('xinzeng') }}
        </el-button>
        <el-button size="mini" type="primary" @click="yt.showEditDialog('hebinghunliaogongdan', null, '80%')" plain>
          {{ $t('hedan') }}
        </el-button>
      </template>

      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>

      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { s1: '工单执行-维尔打印标签' } }">
            <el-button type="text" @click="printLabel(scope.row)">
              {{ $t('dayinbiaoqian') }}
            </el-button>
          </el-col>
          <el-col v-if="scope.row.status === '2'" :span="0.1" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { s1: '混料单-补料' } }">
<!--            <el-button type="text" @click="supplementMaterials(scope.row)">-->
<!--              {{ $t('buliao') }}-->
<!--            </el-button>-->
            <el-button type="text" @click="yt.showEditDialog('hunliaobuliaogongdanchuangjian', scope.row,'80%')">{{ $t('buliao') }} </el-button>
          </el-col>
          <el-col v-if="scope.row.status === '0'" :span="0.1" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { s1: '混料单-删除混料单' } }">
            <el-button type="text" @click="yt.remove(scope.row, 'web/mixture/order/delete')" class="font-color-danger">
              {{ $t('shanchu') }}
            </el-button>
          </el-col>
        </el-row>
      </template>

      <template #yongliaoqingdan="scope">
        <el-row>
          <el-col :span="0.1" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { s1: '查看用料清单' } }">
            <el-button type="text" @click="yt.showEditDialog('hunliaoBOM', scope.row, '50%')">
              {{ $t('chakan') }}
            </el-button>
          </el-col>
        </el-row>
      </template>

      <template #hunliaobiaoqian="scope">
        <el-row>
          <el-col :span="0.1" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { s1: '查看混料清单' } }">
            <el-button type="text" @click="yt.showEditDialog('hunliaobiaoqian', scope.row, '75%')">
              {{ $t('chakan') }}
            </el-button>
          </el-col>
        </el-row>
      </template>

      <template #touliaojilu="scope">
        <el-row>
          <el-col :span="0.1" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { s1: '查看投料记录' } }">
            <el-button type="text" @click="yt.showEditDialog('touliaojilu', scope.row, '75%')">
              {{ $t('chakan') }}
            </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>

    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body" dialog-scroller>
      <template v-if="yt.editObj.action === 'xinzeng'">
        <div class="dialog-scroller">
          <el-form ref="form" :model="orderData" label-width="auto" :inline="true" size="mini">
            <el-form-item :label="$t('shengchangongdanhao')" required>
              <yi_cross_select :max="1" :component="'web_mixture_order_work_order_component'" :ids.sync="orderData.woId"> </yi_cross_select>
            </el-form-item>

            <el-form-item :label="$t('jihuahunliaoshuliang')">
              <el-input v-model="orderData.mixtureWeight" size="mini" clearable disabled></el-input>
            </el-form-item>

            <el-form-item :label="$t('zhixingren')">
              <yi_data_select :type="'customer_user'" :ids.sync="orderData.pic"></yi_data_select>
            </el-form-item>

            <el-form-item :label="$t('beizhu')">
              <el-input v-model="orderData.remark" size="mini" clearable></el-input>
            </el-form-item>
          </el-form>
          <el-divider content-position="left"
            ><span style="font-size: 12px;color: grey;"> {{ $t('yongliaoqingdan') }}</span></el-divider
          >
          <el-form ref="form" label-width="auto" :inline="true" size="mini">
            <el-row v-for="(item, index) in orderData.bomParam" :key="index">
              <el-col :span="1">
                <el-button type="text" icon="el-icon-remove-outline" @click="deleteItem(index)"> </el-button>
              </el-col>
              <el-form-item :label="$t('wuliaomingcheng')">
                <yi_data_select :type="'material2'" :ids.sync="item.materialId" @change="(id, obj) => change(id, obj, index)" required></yi_data_select>
              </el-form-item>
              <el-form-item :label="$t('wuliaobianma')"> <el-input v-model="item.code" disabled></el-input> </el-form-item>

              <el-form-item :label="$t('guige')"> <el-input v-model="item.spec" disabled></el-input> </el-form-item>

              <el-form-item :label="$t('shuliang')"> <el-input-number :min="0" v-model="item.quantity" @change="e => calculate(e, index)"></el-input-number> </el-form-item>

              <el-form-item :label="$t('danwei')"> <el-input v-model="item.unit" disabled></el-input> </el-form-item>
            </el-row>
            <el-button type="text" icon="el-icon-circle-plus-outline" @click="addItem">
              {{ $t('tianjiapeizhi') }}
            </el-button>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="close">{{ $t('quxiao') }}</el-button>
          <el-button :loading="store.state.global_loading" size="mini" type="primary" @click="save">{{ $t('baocun') }} </el-button>
        </span>
      </template>

      <template v-if="yt.editObj.action === 'hunliaoBOM'">
        <div class="dialog-scroller">
          <el-row>
            <span style="font-size: 20; color: grey;"> {{ $t('hunliaogongdanhao') }}:{{ yt.editObj.no }}</span>
          </el-row>
          <mixtureBom :mixtureOrderId="yt.editObj.id"></mixtureBom>
        </div>
      </template>

      <template v-if="yt.editObj.action === 'hunliaobiaoqian'">
        <div class="dialog-scroller">
          <el-row>
            <span style="font-size: 20; color: grey;"> {{ $t('hunliaogongdanhao') }}:{{ yt.editObj.no }}</span>
          </el-row>
          <printLog :mixtureOrderId="yt.editObj.id"></printLog>
        </div>
      </template>

      <template v-if="yt.editObj.action === 'touliaojilu'">
        <div class="dialog-scroller">
          <el-row>
            <span style="font-size: 20; color: grey;"> {{ $t('hunliaogongdanhao') }}:{{ yt.editObj.no }}</span>
          </el-row>
          <feedingList :mixtureOrderId="yt.editObj.id"></feedingList>
        </div>
      </template>
      <template v-if="yt.editObj.action === 'hunliaobuliaogongdanchuangjian'">
        <div class="dialog-scroller">
          <supplementOrder ref="supplementOrders" :orderObj="yt.editObj"></supplementOrder>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" :loading="yt.editObj.loading" @click="submit" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <!--合单--合并混料工单-->
      <template v-if="yt.editObj.action === 'hebinghunliaogongdan'">
        <div class="dialog-scroller">
          <mergeOrders :mergeOrder="yt.editObj" ref="combineOrders"></mergeOrders>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" :loading="yt.editObj.loading" @click.stop="submitCombine" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
    </el-dialog>

    <el-dialog class="print-dialog" :visible.sync="isShowPrintLabel" append-to-body="append-to-body" width="800px">
      <mixturePrintLabel v-if="isShowPrintLabel" :printObj="printObj" @closeDialog="closePrintLabel"></mixturePrintLabel>
    </el-dialog>
  </div>
</template>

<script>
import mixtureBom from './mixture_bom';
import mixturePrintLabel from './print_label';
import printLog from './print_log';
import feedingList from './feeding';
import mergeOrders from '@@/pages/web/material_management/mixture_order/merge_orders/index'
import supplementOrder from '@@/pages/web/material_management/mixture_order/supplement_materials_order'
export default {
  name: 'web_material_management_mixture_order',
  components: { mixtureBom, mixturePrintLabel, printLog, feedingList, supplementOrder,mergeOrders},
  props: {
    // 父组件传过来的参数
    // params: {
    //   type: Object,
    //   default: () => {}
    // }
  },
  data() {
    return {
      isShowPrintLabel: false,
      columns: [
        {
          label: 'hunliaogongdanhao',
          prop: 'no',
          width: 150
        },
        {
          label: 'shengchangongdanhao',
          prop: 'wo.no',
          width: 180
        },
        {
          label: 'shifouhebing',
          prop: 'mergeFlag',
          type: 'tag',
          tags: {
            1: {
              color: '#67C23A',
              text: this.$t('shi')
            },
            0: {
              color: '#F56C6C',
              text: this.$t('fou')
            }
          }
        },
        {
          label: 'shifoubudan',
          prop: 'replenishFlag',
          type: 'tag',
          tags: {
            1: {
              color: '#67C23A',
              text: this.$t('shi')
            },
            0: {
              color: '#F56C6C',
              text: this.$t('fou')
            }
          }
        },
        {
          label: 'gongdanzhuangtai',
          prop: 'status',
          type: 'dictionary',
          key: 'MIXTURE_ORDER_STATUS'
        },
        {
          label: 'chuangjianshijian',
          prop: 'createTime',
          type: 'time',
          width: 180
        },
        {
          label: 'wanchengshijian',
          type: 'time',
          prop: 'finishTime'
        },
        {
          label: 'jihuashuliang',
          prop: 'mixtureWeight'
        },
        {
          label: 'yongliaoqingdan',
          type: 'slot'
        },
        {
          label: 'touliaojilu',
          type: 'slot'
        },
        {
          label: 'hunliaobiaoqian',
          type: 'slot'
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 180
        }
      ],
      initorderData: {
        mixtureWeight: 0,
        bomParam: []
      },
      orderData: {
        mixtureWeight: 0,
        bomParam: []
      }
    };
  },
  created() {
    setTimeout(() => {
      this.yt.get(1);
      this.$set(this.yt.conditions, 'feedingTimeBegin', this.begin());
      this.$set(this.yt.conditions, 'feedingTimeEnd', this.end());
      this.utils.event_hub.$on('COMBINE_REFRESH_SAVE', () => {
        this.yt.isShowEditDialog = false;
        this.yt.get(1);
      });
    }, 300);
  },
  methods: {
    submit(){
      const bomList = this.$refs['supplementOrders'].bomObject
      if (bomList !== null) {
        this.http.post('/web/mixture/order/replenish', {
          ...bomList
        }).then(res=>{
          this.utils.successMessage(this.$t(res.msg));
          this.yt.isShowEditDialog = false
          this.yt.get(1);
        }).catch(error => {
          this.$message.error(error);
        })
      }else {
        this.utils.errorMessage(this.$t('qingtianxiebencibuliaozhongliang'));
      }
    },
    submitCombine() {
      this.yt.editObj.loading = true;
      let orderIds = this.$refs['combineOrders'].planIdList;
      if (orderIds.length >= 2) {
        this.utils.event_hub.$emit('COMBINE_REFRESH');
        this.yt.editObj.loading = false;
      } else {
        this.utils.errorMessage(this.$t('zhiyouxuanzelianghangyishangcaiyunxuhebing'));
        this.yt.editObj.loading = false;
      }
    },
    begin() {
      const date = new Date();
      const begin = new Date(date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + '01' + ' 00:00:00').getTime();
      return begin;
    },
    end() {
      const date = new Date();
      const end = new Date(date.getFullYear(), date.getMonth() + 1, 0, 23, 59, 59).getTime();
      return end;
    },
    addItem() {
      this.orderData.bomParam.push({
        materialId: '',
        code: '',
        spec: '',
        quantity: '',
        unit: ''
      });
    },
    deleteItem(key) {
      this.orderData.bomParam = this.orderData.bomParam.filter((item, index) => {
        return index !== key;
      });
    },
    close() {
      this.$confirm('是否退出混料工单创建，未提交的记录将丢失', this.$t('tishi'), {
        confirmButtonText: this.$t('queding'),
        cancelButtonText: this.$t('quxiao'),
        type: 'error'
      }).then(() => {
        this.yt.isShowEditDialog = false;
        this.orderData = JSON.parse(JSON.stringify(this.initorderData));
      });
    },
    save() {
      if (!this.orderData.woId) {
        return this.$message.error(this.$t('qingxuanzeshengchangongdan'));
      }
      if (this.orderData.bomParam.length < 2) {
        return this.$message.error(this.$t('qingtianjialianghzongwuliao'));
      }
      for (let i = 0; i < this.orderData.bomParam.length; i++) {
        if (!this.orderData.bomParam[i].materialId) {
          return this.$message.error(this.$t('qingxaunze') + (i + 1) + this.$('dewuliao'));
        }
      }

      if (this.hasDuplicates(this.orderData.bomParam, 'materialId')) {
        return this.$message.error(this.$t('cunzaixiangtongwuliao'));
      }
      if (this.orderData.mixtureWeight <= 0) {
        return this.$message.error(this.$('bunengweiling'));
      }
      this.http
        .post('web/mixture/order/create', this.orderData)
        .then(res => {
          this.utils.successMessage(this.$t('success'));
          this.yt.isShowEditDialog = false;
          this.orderData = JSON.parse(JSON.stringify(this.initorderData));
          this.yt.get(1);
        })
        .catch(e => {
          this.$message.error(this.$t(e));
        });
    },
    hasDuplicates(array, key) {
      const seen = new Set();
      for (const item of array) {
        if (seen.has(item[key])) {
          return true;
        }
        seen.add(item[key]);
      }
      return false;
    },

    change(a, b, index) {
      console.log(a, b);
      this.orderData.bomParam[index].code = b.code;
      this.orderData.bomParam[index].spec = b.spec;
      this.orderData.bomParam[index].unit = b.unit;
    },
    calculate(e, index) {
      let bomUnit = this.orderData.bomParam[index].unit;
      if (!bomUnit) {
        return;
      }
      if (bomUnit.toLowerCase() === 'kg') {
        this.orderData.mixtureWeight = this.orderData.mixtureWeight + e;
      }
    },
    printLabel(mixtureOrder) {
      this.printObj = this.utils.copy(mixtureOrder);

      this.isShowPrintLabel = true;
    },
    closePrintLabel() {
      this.isShowPrintLabel = false;
    }
  }
};
</script>

<style scoped lang="scss">
._form /deep/ .el-input__inner {
  -webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: inherit;
  // height: 40px;
  line-height: 40px;
  outline: none;
  padding: 0 15px;
  -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  width: 120px;
}

.print-dialog .el-dialog {
  .el-dialog__body {
    max-height: none;
  }
}
</style>
